<template>
    <div class="ht-page">
        <div class="ht-header">
            <div class="ht-header-left">
                <div class="ht-icon-wrap"><i class="fas fa-umbrella-beach"></i></div>
                <h2 class="ht-title">Holiday Types</h2>
                <span class="ht-count" v-if="items.length">{{ items.length }}</span>
            </div>
            <button class="ht-add-btn" @click="toggleForm">
                <i :class="showForm && !editMode ? 'fas fa-times' : 'fas fa-plus'"></i>
                {{ showForm && !editMode ? 'Close' : 'Add Type' }}
            </button>
        </div>

        <div class="ht-form-card" v-if="showForm">
            <Form :fields="createFields" title="Holiday Type" submitUrl="/attendance-holiday-types"
                updateRootUrl="/attendance-holiday-types" @success="handleFormSuccess" @cancel="closeForm"
                :editMode="editMode" :editData="editData" />
        </div>

        <div v-if="loading" class="ht-loading"><div class="ht-spinner"></div><span>Loading...</span></div>
        <div v-else-if="!items.length" class="ht-empty">
            <div class="ht-empty-icon"><i class="fas fa-umbrella-beach"></i></div>
            <h3>No holiday types found</h3>
        </div>
        <div v-else class="ht-grid">
            <div class="ht-card" v-for="(item, idx) in items" :key="item.id" :style="{ animationDelay: `${idx * 0.03}s` }">
                <div class="ht-card-top">
                    <div class="ht-card-icon" :class="htColor(idx)"><i class="fas fa-calendar-star"></i></div>
                    <h4 class="ht-card-name">{{ item.name }}</h4>
                </div>
                <div class="ht-card-actions">
                    <button class="ht-action-btn ht-btn-edit" @click="enableEditing(item)"><i class="fas fa-pen"></i> Edit</button>
                    <button class="ht-action-btn ht-btn-delete" @click="deleteItem(item.id)"><i class="fas fa-trash-alt"></i> Delete</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../components/crud/form.vue"
import { createField } from "../../utils/common"
import { http } from "../../utils/http"

export default {
    data() {
        return {
            createFields: [createField("Name*", "name", "text", true)],
            items: [],
            loading: true,
            showForm: false,
            editMode: false,
            editData: null,
        }
    },
    components: { Form },
    mounted() { this.fetchData() },
    methods: {
        htColor(i) { return ["ht-clr-blue","ht-clr-purple","ht-clr-teal","ht-clr-amber","ht-clr-rose"][i % 5] },
        toggleForm() { if (this.showForm && !this.editMode) { this.closeForm() } else { this.editMode = false; this.editData = null; this.showForm = true } },
        closeForm() { this.showForm = false; this.editMode = false; this.editData = null },
        handleFormSuccess() { this.closeForm(); this.fetchData() },
        enableEditing(item) { this.editMode = true; this.editData = { ...item }; this.showForm = true; window.scrollTo({ top: 0, behavior: "smooth" }) },
        async fetchData() {
            this.loading = true
            try { const res = await http.get("/attendance-holiday-types"); this.items = res.data.result || [] } catch (err) { console.log(err) }
            this.loading = false
        },
        async deleteItem(id) {
            if (!confirm("Delete this holiday type?")) return
            try { await http.delete(`/attendance-holiday-types/${id}`); this.$toast.success("Deleted"); this.items = this.items.filter(c => c.id !== id) }
            catch (e) { this.$toast.error("Error deleting") }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";
.ht-page { animation: htFade .3s ease; }
@keyframes htFade { from { opacity:0; transform:translateY(4px); } to { opacity:1; transform:translateY(0); } }
.ht-header { display:flex; align-items:center; justify-content:space-between; gap:12px; background:white; border:1px solid $gray100; border-radius:8px; padding:10px 16px; margin-bottom:12px; box-shadow:$shadowSm; flex-wrap:wrap; }
.ht-header-left { display:flex; align-items:center; gap:10px; }
.ht-icon-wrap { width:32px; height:32px; border-radius:8px; background:linear-gradient(135deg,$primaryLight,darken($primaryLight,4%)); color:$primaryColor; display:flex; align-items:center; justify-content:center; font-size:14px; }
.ht-title { font-size:15px; font-weight:700; color:$gray800; margin:0; }
.ht-count { min-width:20px; height:20px; padding:0 6px; border-radius:$radiusFull; font-size:11px; font-weight:700; background:$primaryColor; color:white; display:inline-flex; align-items:center; justify-content:center; }
.ht-add-btn { display:inline-flex; align-items:center; gap:6px; padding:7px 14px; border:none; border-radius:6px; background:$primaryColor; color:white; font-size:12.5px; font-weight:600; cursor:pointer; transition:all $transitionFast; font-family:inherit; &:hover { background:$primaryDark; } }
.ht-form-card { background:white; border:1px solid $gray100; border-radius:10px; padding:16px; margin-bottom:12px; box-shadow:$shadowSm; }
.ht-loading { display:flex; align-items:center; justify-content:center; gap:10px; padding:64px 16px; background:white; border:1px solid $gray100; border-radius:8px; box-shadow:$shadowSm; span { font-size:13px; color:$gray400; } }
.ht-spinner { width:24px; height:24px; border:2.5px solid $gray200; border-top-color:$primaryColor; border-radius:50%; animation:htSpin .7s linear infinite; }
@keyframes htSpin { to { transform:rotate(360deg); } }
.ht-empty { text-align:center; padding:64px 16px; background:white; border:1px solid $gray100; border-radius:8px; box-shadow:$shadowSm; h3 { font-size:14px; font-weight:700; color:$gray600; margin:0; } }
.ht-empty-icon { width:48px; height:48px; border-radius:$radiusFull; background:$gray50; border:1px solid $gray100; display:flex; align-items:center; justify-content:center; margin:0 auto 12px; i { font-size:20px; color:$gray300; } }
.ht-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:10px; }
.ht-card { background:white; border:1px solid $gray100; border-radius:10px; padding:14px; box-shadow:$shadowSm; display:flex; flex-direction:column; gap:10px; animation:htSlide .25s ease both; transition:all $transitionFast; &:hover { border-color:$gray200; box-shadow:$shadowMd; transform:translateY(-1px); } }
@keyframes htSlide { from { opacity:0; transform:translateY(4px); } to { opacity:1; transform:translateY(0); } }
.ht-card-top { display:flex; align-items:center; gap:10px; }
.ht-card-icon { width:34px; height:34px; border-radius:8px; display:flex; align-items:center; justify-content:center; font-size:13px; flex-shrink:0; }
.ht-clr-blue { background:#eff6ff; color:#2563eb; }
.ht-clr-purple { background:#f5f3ff; color:#7c3aed; }
.ht-clr-teal { background:#f0fdfa; color:#0d9488; }
.ht-clr-amber { background:#fffbeb; color:#d97706; }
.ht-clr-rose { background:#fff1f2; color:#e11d48; }
.ht-card-name { font-size:13px; font-weight:700; color:$gray800; margin:0; }
.ht-card-actions { display:flex; gap:6px; margin-top:auto; padding-top:6px; border-top:1px solid $gray100; }
.ht-action-btn { display:inline-flex; align-items:center; gap:4px; padding:4px 10px; border:1px solid $gray200; border-radius:5px; font-size:11px; font-weight:600; cursor:pointer; transition:all $transitionFast; font-family:inherit; background:white; i { font-size:10px; } }
.ht-btn-edit { color:$primaryColor; &:hover { background:$primaryLight; border-color:rgba(0,94,137,0.15); } }
.ht-btn-delete { color:$danger; &:hover { background:#fef2f2; border-color:rgba(220,38,38,0.15); } }
@media(max-width:992px) { .ht-grid { grid-template-columns:repeat(2,1fr); } }
@media(max-width:480px) { .ht-grid { grid-template-columns:1fr; } }
</style>
